import { ActionButton, ImageUploader } from '@emerald-works-nova/components'
import { Box, Button, Checkbox, Dialog, DialogTitle, FormControlLabel, Grid, TextField } from '@mui/material'
import React from 'react'
import { useStyles } from './style'
import ImageDisplay from '../../image-display'

export function EditCategoryModal ({
  open,
  isWorking,
  category,
  onCancel = () => { },
  onClose = () => { }
}) {
  const classes = useStyles()
  const recommendedCharCount = 600
  const [name, setName] = React.useState('')
  const [description, setDescription] = React.useState('')
  const [hideFromLPQ, setHideFromLPQ] = React.useState(false)
  const [imageInfo, setImageInfo] = React.useState({
    name: '',
    imgUrl: '',
    s3Url: '',
    width: 0,
    height: 0,
    altText: '',
    author: '',
    stock: ''
  })

  const helperText = description.length > recommendedCharCount
    ? `${description.length} | Exceeding ${recommendedCharCount} characters may result in unpredictable layout issues.`
    : `${description.length}`

  React.useEffect(() => {
    category.name && setName(category.name)
    category.description && setDescription(category.description)
    category.imageInfo && setImageInfo(category.imageInfo)
    category.hideFromLPQ && setHideFromLPQ(category.hideFromLPQ)
  }, [category, category.name, category.description, category.imageInfo])

  const handleOnDropAccepted = React.useCallback(imgInfo => {
    setImageInfo(imgInfo)
  }, [setImageInfo])

  React.useEffect(() => {
    !open && setName('')
    !open && setDescription('')
    !open && setImageInfo({
      name: '',
      imgUrl: '',
      s3Url: '',
      width: 0,
      height: 0,
      altText: '',
      author: '',
      stock: ''
    })
  }, [open])

  return (
    <Dialog open={open} classes={{ paper: classes.dialogPaper }} aria-labelledby='rename-category-title'>
      <DialogTitle id='rename-category-title' className={classes.dialogTitle}>
        <Grid container className={classes.actionBtnCtn}>
          <Grid item xs={8}>Edit Category</Grid>
          <Grid container item xs={4} justifyContent='flex-end'>
            <Button
              color='primary'
              data-test='cancel-button'
              className={classes.cancelBtn}
              onClick={onCancel}
            > Cancel
            </Button>
            <ActionButton
              variant='primary'
              dataTest='save-button'
              className={classes.saveBtn}
              onClick={() => onClose(category, name, description, imageInfo, hideFromLPQ)}
              isWorking={isWorking}
              disabled={name.length === 0}
            >
              Save
            </ActionButton>
          </Grid>
        </Grid>
      </DialogTitle>

      <Box display='flex' flexDirection='column'>
        <TextField
          autoFocus
          value={name}
          className={classes.input}
          variant='outlined'
          placeholder='Add title'
          label='Title'
          onChange={ev => setName(ev.target.value)}
          data-test='category-title'
          required
        />
      </Box>
      <Box display='flex' flexDirection='column' data-test='category-description-container'>
        <TextField
          multiline
          rows={3}
          value={description}
          className={classes.input}
          variant='outlined'
          placeholder='Add description'
          label='Category Description'
          onChange={ev => setDescription(ev.target.value)}
          data-test='category-description-text'
          helperText={
            <div className={classes.helperText}>
              <strong>Characters: </strong> {helperText}
            </div>
          }
        />
        <Box mt={2} data-test='category-description-image-container'>
          {!imageInfo.imgUrl ? (
            <ImageUploader
              onDropAccepted={handleOnDropAccepted}
              imageNamePrefix={category.name}
              validation={{ minWidth: 392, minHeight: 220 }}
              data-test='category-description-image-uploader'
            />
          ) : (
            <ImageDisplay
              imageInfo={imageInfo}
              setImageInfo={setImageInfo}
            />
          )}
        </Box>
      </Box>
      <Box marginBottom={3} display='flex' flexDirection='column' data-test='category-hide-from-lpq-container'>
        <FormControlLabel
          control={
            <Checkbox
              value={hideFromLPQ}
              checked={hideFromLPQ}
              onChange={() => setHideFromLPQ(!hideFromLPQ)}
              data-test='category-hide-from-lpq-checkbox'
            />
          }
          label='Hide from LPQ'
        />
      </Box>
    </Dialog>
  )
}
